import Head from 'next/head';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import 'styles/Home.module.css';

import TechnologyStories from 'app/components/TechnologyPodcast/TechnologyStories';
import Metatag from 'app/components/metaTag';
import REQUEST from 'app/helpers/http.service';
import {
  TECHNOLOGY_PODCAST,
  AWARDS,
  COMMON_NEWSROOM,
  PODCAST_PLATFORM,
  TECHNOLOGY_PODCAST_DETAIL,
} from 'app/helpers/apiEndpoint';
import AwardWinningBar from 'app/components/Home/AwardWinningBar';
import PodcastEpisode from 'app/components/common/PodcastEpisode';
import Container from 'app/components/common/Container';
import PlatformList from 'app/components/common/PlatformList';
import PodCastBanner from 'app/components/common/PodCastBanner';
import PodCastSubscribe from 'app/components/common/PodCastSubscribe';

import '../../pages/home.css';
const WriteGetInTouch = dynamic(
  () => import('app/components/writetous/WriteGetInTouch')
);

export default function TechnologyPodcast({ res }) {
  const { podcast, podcastDetail, awards, newsData, podcastPlatform } =
    JSON.parse(res);
  const { asPath } = useRouter();
  const router = useRouter();
  const canonicalUrl = (
    `${process.env.NEXT_PUBLIC_BASE_URL}` + (asPath === '/' ? '' : asPath)
  ).split('?')[0];

  if (router.isFallback) {
    return <div>Loading...</div>;
  }
  return (
    <div className="md:pt-[80px] pt-[70px]">
      <Head>
        <title>{podcast?.title ? podcast?.title : `VLink`}</title>
        <meta
          name="description"
          content={podcast?.description || 'Vlink Description'}
        />
        <meta
          property="og:title"
          content={podcast?.Seo?.metaTitle || podcast?.title || `Vlink`}
        />
        <meta
          property="og:description"
          content={
            podcast?.Seo?.metaDescription ||
            podcast?.description ||
            'Vlink Description'
          }
        />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_BASE_URL}${asPath}`}
        />
        <Metatag
          content={
            podcast?.Seo?.metaImage?.data?.attributes?.url ||
            podcastDetail[0]?.attributes?.playlist_data?.playlist_img?.data
              ?.attributes?.url
          }
          pageUrl={canonicalUrl}
        />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="use-credentials"
        />
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <PodCastBanner data={podcast?.section1} isService={true} ishome={true} />
      <AwardWinningBar section={awards} newdev={true} bgcolor={true} />
      <section className="md:py-[80px] py-[70px]">
        <Container>
          <div className="grid grid-cols-12 gap-x-10">
            <h3 className="col-span-12 xl:text-[58px] lg:text-[40px] text-[35px] text-[#0C2139] font-[700]">
              All Episodes
            </h3>
            <div className="lg:col-span-9 col-span-12">
              <PodcastEpisode
                podcastDetail={podcastDetail}
                isPodCast={'North America'}
                podcastSeasons={podcast?.Seasons}
              />
            </div>
            <div className="lg:col-span-3 col-span-12">
              <PlatformList platformlist={podcastPlatform} />
            </div>
          </div>
        </Container>
      </section>
      <TechnologyStories
        section_content={newsData}
        section_title={podcast?.section3}
        isDetail={false}
      />
      <section className="md:mt-[80px] mt-[70px]">
        <Container>
          <PodCastSubscribe
            subscribe={podcastPlatform?.Subscribe}
            classAtt={
              'bg-[#0050D5] rounded-[8px] shadow-[0px_4px_6px_-1px_#00000040] py-[100px] xl:px-14 lg:px-8 px-6'
            }
            grid={'lg:grid-cols-2 grid-cols-1 gap-10'}
            font={
              'font-[700] xl:text-[58px] lg:text-[46px] sm:text-[32px] text-[24px]'
            }
            btn={
              'bg-[#ffffff] py-3 rounded-[2px] px-4 w-full font-bold xl:text-[24px] text-[20px] text-[#0050D5] mb-2'
            }
          />
        </Container>
      </section>
      <div className="xl:mt-[30px] mt-[0px]">
        <WriteGetInTouch />
      </div>
    </div>
  );
}

export async function getStaticProps() {
  const [podcast, awards, newsData, podcastPlatform] = await Promise.all([
    REQUEST({
      method: 'GET',
      url: TECHNOLOGY_PODCAST,
    }),
    REQUEST({
      method: 'GET',
      url: AWARDS,
    }),
    REQUEST({
      method: 'GET',
      url: COMMON_NEWSROOM,
    }),
    REQUEST({
      method: 'GET',
      url: PODCAST_PLATFORM,
    }),
  ]);
  let page = 1;
  let limit = 20;
  let contentPages = [];
  let total = 0;
  do {
    const [res] = await Promise.all([
      REQUEST({
        method: 'GET',
        url: `${TECHNOLOGY_PODCAST_DETAIL}&pagination[page]=${page}&pagination[pageSize]=${limit}`,
      }),
    ]);
    contentPages = [...contentPages, ...(res?.data?.data || [])];
    if (res?.data?.meta?.pagination?.total) {
      total = res?.data?.meta?.pagination?.total;
      page = page + 1;
    } else break;
  } while (total > contentPages.length);
  const res = JSON.stringify({
    podcast: podcast?.data?.data?.attributes,
    podcastDetail: contentPages,
    awards: awards?.data?.data?.attributes,
    newsData: newsData?.data?.data,
    podcastPlatform: podcastPlatform?.data?.data[0]?.attributes,
  });
  return {
    props: {
      res,
    },
  };
}
